export default __webpack_public_path__ + "static/media/aero.899bc9bf.svg";